export default __webpack_public_path__ + "static/media/mina.c34ee0a2.jfif";